export default __webpack_public_path__ + "static/estimator-baby-mobile-fbba5c6bcd7c657a432c78ae1c5059a9.svg";